<script lang="ts">
  import type { StorePinData } from './storeTypes';
  import { DEBUG_CONFIG } from '../mapConstants';

  // Props
  export let mapSvgElement: SVGSVGElement | null = null;
  export let currentFloorId: number | null = null;
  export let cachedPinsByFloor: Map<number, StorePinData[]> = new Map();
  export let activeFloorPins: StorePinData[] = [];
  export let highlightedStoreId: string | null = null;
  
  // Viewport debug props
  export let viewportStats: {
    x: number;
    y: number;
    width: number;
    height: number;
    zoomLevel: number;
    atMinZoom: boolean;
    atMaxZoom: boolean;
    atPanBoundary: boolean;
  } | null = null;
  
  // Debug panel sections toggle
  let showViewportStats = true;
</script>

{#if $DEBUG_CONFIG.showDebugPanels}
<div class="debug-info">
  {#if !mapSvgElement}
    <div>Looking for SVG element...</div>
  {:else}
    <div>SVG Ready ✓</div>
  {/if}
  <div class="floor-info">Current Floor: {currentFloorId}</div>
  <div>Floors with pins: {cachedPinsByFloor.size}</div>
  <div>Active pins: {activeFloorPins.length}</div>
  <div>Highlighted: {highlightedStoreId || 'none'}</div>
  
  <!-- SVG Viewport Stats -->
  {#if viewportStats && showViewportStats}
    <div class="viewport-stats">
      <button class="toggle-btn" on:click={() => showViewportStats = !showViewportStats}>
        {showViewportStats ? '▼' : '►'} Viewport
      </button>
      <div class="stats-content">
        <div>
          {Math.round(viewportStats.x)},{Math.round(viewportStats.y)} 
          {Math.round(viewportStats.width)}×{Math.round(viewportStats.height)}
        </div>
        <div>Zoom: {viewportStats.zoomLevel.toFixed(1)}%</div>
        
        <!-- Boundary indicators -->
        <div class="boundary-indicators">
          {#if viewportStats.atMinZoom}<span class="indicator">Min zoom</span>{/if}
          {#if viewportStats.atMaxZoom}<span class="indicator">Max zoom</span>{/if}
          {#if viewportStats.atPanBoundary}<span class="indicator">Pan limit</span>{/if}
        </div>
      </div>
    </div>
  {:else}
    <div class="viewport-stats">
      <button class="toggle-btn" on:click={() => showViewportStats = !showViewportStats}>
        {showViewportStats ? '▼' : '►'} Viewport
      </button>
      {#if showViewportStats}
        <div class="stats-content">
          <div class="debug-message">No viewport stats available</div>
          <div class="debug-detail">viewportStats is {viewportStats === null ? 'null' : 'undefined'}</div>
        </div>
      {/if}
    </div>
  {/if}
</div>
{/if}

<style>
  .debug-info {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 199;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 8px;
    border-radius: 4px;
    font-size: 12px;
    font-family: monospace;
    pointer-events: auto;
    border: 1px solid #ccc;
    max-height: 100%;
    overflow-y: auto;
    width: 250px;
  }
  
  /* Add styles for debug messages */
  .debug-message {
    color: #e74c3c;
    font-weight: bold;
    margin-top: 5px;
  }
  
  .debug-detail {
    font-size: 10px;
    color: #777;
    margin-top: 2px;
    font-style: italic;
  }
  
  .floor-info {
    border-radius: 3px;
    margin: 2px 0;
  }
  
  .viewport-stats {
    margin-top: 5px;
    border-top: 1px solid #ddd;
    padding-top: 5px;
  }
  
  .toggle-btn {
    background: none;
    border: none;
    padding: 2px 0;
    margin: 0;
    font-family: monospace;
    font-size: 12px;
    cursor: pointer;
    text-align: left;
    width: 100%;
    color: #0066cc;
  }
  
  .toggle-btn:hover {
    text-decoration: underline;
  }
  
  .stats-content {
    padding-left: 10px;
    margin-top: 3px;
  }
  
  .boundary-indicators {
    margin-top: 3px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
  
  .indicator {
    background-color: rgba(0, 0, 0, 0.1);
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 10px;
  }
</style> 